/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FormCompletionAcceptedOutput,
  FormCompletionInput,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * Enqueues a background job to generate AI completion for form fields. The result is delivered via ActionCable broadcast.
 * @summary Generate form completion using AI
 */
export const createFormCompletion = (
    formCompletionInput?: MaybeRefOrGetter<FormCompletionInput>,
 signal?: AbortSignal
) => {
      formCompletionInput = toValue(formCompletionInput);

      return axiosClient<FormCompletionAcceptedOutput>(
      {url: `/form_completions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formCompletionInput, signal
    },
      );
    }




export const getCreateFormCompletionMutationKey = () => ['createFormCompletion'] as const;

export const getCreateFormCompletionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFormCompletion>>, TError,CreateFormCompletionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFormCompletion>>, TError,CreateFormCompletionMutationVariables, TContext> => {

const mutationKey = getCreateFormCompletionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFormCompletion>>, CreateFormCompletionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFormCompletion(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFormCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof createFormCompletion>>>
    export type CreateFormCompletionMutationBody = FormCompletionInput | undefined
    export type CreateFormCompletionMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateFormCompletionMutationVariables = {data?: FormCompletionInput}

    /**
 * @summary Generate form completion using AI
 */
export const useCreateFormCompletion = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFormCompletion>>, TError,CreateFormCompletionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFormCompletion>>,
        TError,
        CreateFormCompletionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFormCompletionMutationOptions(options), queryClient);
    }
